module.exports = __webpack_public_path__ + "media/images/blanc-4e6bf3668be1a984ddc065f675d33072.png";